module.exports = __webpack_public_path__ + "img/headset-logo.695dc0db.png";